import { render, staticRenderFns } from "./pamm-statistics.vue?vue&type=template&id=6fe32f54&"
import script from "./pamm-statistics.vue?vue&type=script&lang=js&"
export * from "./pamm-statistics.vue?vue&type=script&lang=js&"
import style0 from "./pamm-statistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports